// Integração com o WhatsApp via uazapi — Administração > Conta &
// Integrações > Integrações (card WhatsApp). Ao contrário do Asaas (cada
// empresa traz a própria chave), aqui a conta é CENTRALIZADA (admintoken
// nosso no backend) — a empresa só clica "Conectar" e escaneia o QR code,
// nunca digita nenhum token. Mesmo padrão de
// gpsdrive-asaas-integration.service.ts.
import { gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export interface WhatsappIntegrationStatus {
  // false quando o backend não tem UAZAPI_ADMIN_TOKEN configurado nesta
  // implantação — a tela mostra "indisponível" em vez de um botão que
  // sempre falharia.
  available: boolean;
  connected: boolean;
  status: string;
  phone: string | null;
  // Instância já existente vinculada pelo Super Master (compartilhada com
  // outro sistema) — a empresa não conecta nem desconecta nada.
  external?: boolean;
}

export interface WhatsappConnectResult {
  qrcode: string | null;
  paircode: string | null;
  connected: boolean;
}

export const gpsDriveWhatsappIntegrationService = {
  getStatus: () => gpsDriveGet<WhatsappIntegrationStatus>("/api/v1/integrations/whatsapp/status"),
  connect: () => gpsDrivePost<WhatsappConnectResult>("/api/v1/integrations/whatsapp/connect", {}),
  disconnect: () => gpsDrivePost<{ ok: boolean }>("/api/v1/integrations/whatsapp/disconnect", {}),
};
